import { regex } from './regex'
/**
 * Determines if a string is a valid UUID.
 *
 * @param {any} identifier The identifier to check.
 * @returns true or false
 */
export function isValidUUID (identifier) {
  return regex.UUID.test(identifier)
}
